import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { TextField, MenuItem, Button, Box, Typography, FormControl, InputLabel, Select } from "@mui/material";
import styles from "./ContactUs.module.css";

function ContactUs() {
  return (
    <div className={styles.main}>
      <Navbar />
      <Box className={styles.container}>
        {/* Left Image Section */}
        <Box className={styles.leftSection}></Box>

        {/* Right Contact Form Section */}
        <Box className={styles.rightSection}>
          <Typography variant="h5" className={styles.heading}>
            Need to contact us?
          </Typography>
          <TextField
            label="Full Name"
            variant="outlined"
            fullWidth
            className={styles.input}
            defaultValue="Leonardo"
            InputProps={{ sx: { color: '#fff' } }}
          />
          <FormControl fullWidth className={styles.input}>
            <InputLabel sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>Reason For Contact</InputLabel>
            <Select 
              defaultValue=""
              sx={{ color: '#fff', '& .MuiSvgIcon-root': { color: 'white' } }}
            >
              <MenuItem value="">Select a choice</MenuItem>
              <MenuItem value="support">Support</MenuItem>
              <MenuItem value="feedback">Feedback</MenuItem>
              <MenuItem value="inquiry">General Inquiry</MenuItem>
            </Select>
          </FormControl>
          <TextField
            label="Contact Email"
            variant="outlined"
            fullWidth
            className={styles.input}
            defaultValue="example@email.com"
            InputProps={{ sx: { color: '#fff' } }}
          />
          <TextField
            label="Message"
            variant="outlined"
            fullWidth
            multiline
            rows={4}
            className={styles.input}
            defaultValue="Your Message"
            InputProps={{ sx: { color: '#fff' } }}
          />
          <Button 
            variant="contained" 
            fullWidth 
            className={styles.button}
            sx={{ transition: 'all 0.3s ease' }}
          >
            Send Message
          </Button>
        </Box>
      </Box>
      <Footer />
    </div>
  );
}

export default ContactUs;